/**
 * B2B Access Guard
 * Prevents non-B2B customers from manipulating cart via AJAX or form submissions
 * 
 * This script runs only for non-verified B2B customers to prevent:
 * - Direct cart form submissions
 * - AJAX cart operations
 * - URL manipulation to access cart
 */

(function() {
  'use strict';
  
  // Check if customer is B2B verified (set via data attribute on body)
  const isB2BVerified = document.body.dataset.customerB2b === 'true';
  
  // If already verified, no need to run guard
  if (isB2BVerified) {
    return;
  }
  
  console.log('[B2B Guard] Active - Cart operations are restricted');
  
  /**
   * Intercept all form submissions that target cart operations
   */
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    // Check if it's a cart-related form
    if (
      form.action && (
        form.action.includes('/cart/add') ||
        form.action.includes('/cart/update') ||
        form.action.includes('/cart/change') ||
        form.action.includes('/cart/clear')
      )
    ) {
      e.preventDefault();
      e.stopPropagation();
      
      // Show appropriate message based on login status
      const isLoggedIn = document.body.dataset.customerLoggedIn === 'true';
      
      if (isLoggedIn) {
        alert('Your B2B account is pending verification. You will be able to add items to cart once approved.');
      } else {
        alert('Please login with a verified B2B account to add items to cart.');
        window.location.href = '/account/login';
      }
      
      return false;
    }
  }, true); // Use capture phase to catch before other handlers
  
  /**
   * Intercept AJAX cart requests (Fetch API)
   */
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    
    // Check if it's a cart-related fetch request
    if (
      typeof url === 'string' && (
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/change') ||
        url.includes('/cart/clear') ||
        url.includes('/cart.js')
      )
    ) {
      console.warn('[B2B Guard] Blocked cart operation:', url);
      
      // Return a rejected promise
      return Promise.reject(new Error('B2B verification required'));
    }
    
    // Allow other fetch requests
    return originalFetch.apply(this, args);
  };
  
  /**
   * Intercept XMLHttpRequest (for older AJAX implementations)
   */
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    // Store the URL for later checking
    this._url = url;
    return originalXHROpen.apply(this, [method, url, ...rest]);
  };
  
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(...args) {
    // Check if it's a cart-related XHR request
    if (
      this._url && (
        this._url.includes('/cart/add') ||
        this._url.includes('/cart/update') ||
        this._url.includes('/cart/change') ||
        this._url.includes('/cart/clear') ||
        this._url.includes('/cart.js')
      )
    ) {
      console.warn('[B2B Guard] Blocked XHR cart operation:', this._url);
      
      // Abort the request
      this.abort();
      return;
    }
    
    return originalXHRSend.apply(this, args);
  };
  
  /**
   * Disable "Add to Cart" buttons visually as backup
   */
  function disableCartButtons() {
    const addToCartButtons = document.querySelectorAll(
      'button[name="add"], ' +
      'button[type="submit"][form*="product"], ' +
      '.js-add-to-cart, ' +
      '[data-action="add-to-cart"]'
    );
    
    addToCartButtons.forEach(button => {
      // Only disable if not already disabled
      if (!button.disabled && button.closest('form')?.action?.includes('/cart/add')) {
        button.disabled = true;
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
        button.title = 'B2B verification required';
      }
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableCartButtons);
  } else {
    disableCartButtons();
  }
  
  // Re-run when dynamic content is added (for AJAX-loaded products)
  const observer = new MutationObserver(disableCartButtons);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();
